export const attendanceOptions: {name: string, value: string}[] = [
  {name: 'present', value: 'present'},
  {name: 'excused', value: 'excused'},
  {name: 'absent', value: 'absent'},
];